import moment from 'moment';
import { Fragment, PureComponent, ReactNode } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { GlobalState } from '../../../store/reducers';
import { PatientDetailsVisits } from '../../../store/reducers/prescriptionPad';
import { getPatientDetailsVisits } from '../../../store/selectors/prescriptionPad';
import { Tool } from '../../../store/types/prescription';
import { configs } from './MagicBoxConfigs';
import { MAGIC_BOX_COMPONENTS } from './MAGIC_BOX_COMPONENTS';
import { changePathAndFocus } from './magicBoxUtils';
import VitalsEmpty from './VitalsEmpty';
import { RouterProps } from './routerProps';

interface Props extends RouteComponentProps<RouterProps> {
    visits?: PatientDetailsVisits;
}

class Vitals extends PureComponent<Props> {
    onVitalsButtonClick = () => {
        const { match, history } = this.props;
        const { pxId } = match.params;

        changePathAndFocus(
            configs[MAGIC_BOX_COMPONENTS.VITALS].elId,
            history,
            pxId,
            'edit',
            undefined,
        );
    };

    render(): ReactNode {
        const { visits } = this.props;
        const filteredVitals = visits?.data
            ?.map((visit) => visit.vitals && visit.vitals.length > 0 && visit)
            .filter(Boolean);

        if (!filteredVitals?.length) {
            return <VitalsEmpty handleCta={this.onVitalsButtonClick} />;
        }

        return (
            <div className="font-400 text-13 mx-12 mt-16 pb-10">
                {(filteredVitals as (Tool & { date: string })[]).map((visit, index) => (
                    <Fragment>
                        <div className="flex flex-col space-y-9">
                            <p className="font-700 sticky top-0 bg-white">
                                {moment(visit?.date).format("DD MMM'YY")}
                            </p>
                            {visit?.vitals?.map((vital) => (
                                <div className="flex justify-between space-x-5">
                                    <p className="text-darwin-neutral-900">
                                        {vital.name}{' '}
                                        {vital.value.unit ? `(${vital.value.unit})` : ''}
                                    </p>
                                    <p className="font-700">{vital.value.qt}</p>
                                </div>
                            ))}
                        </div>
                        {index !== filteredVitals.length - 1 && (
                            <p className="h-5 bg-darwin-neutral-50 w-full my-12 rounded-full"></p>
                        )}
                    </Fragment>
                ))}
            </div>
        );
    }
}

export default connect((state: GlobalState) => ({
    visits: getPatientDetailsVisits(state),
}))(withRouter(Vitals));
